import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import API from '@resi-media/api-types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@destinationId/summary`,
    responseSchema: API.Central.V3.ContentDestinations.Get.Summary,
    params: {} as { destinationId: string },
    method: HTTP_METHODS.GET,
  },
};

export const id = {};
